import { usePresaleCartStock } from "@/hooks/usePresaleCart";
import PriceComponent from "@/components/ui/Price";
import useFixedBarHeight, { PAGE_FIXED_FOOTER_HEIGHT_VAR } from "@/hooks/useFixedBarHeight";
import { SubmitButton } from "@/components/pages/Cart/_CartSummary";

const Index = ({ cart }) => {
	const { check_if_all_items_exist } = usePresaleCartStock();
	const barRef = useFixedBarHeight(PAGE_FIXED_FOOTER_HEIGHT_VAR);

	return (
		<>
			{check_if_all_items_exist &&
				<div
					ref={barRef}
					style={{ bottom: "var(--footer-nav-height, 0px)" }}
					className="lg:hidden fixed inset-x-0 bg-jmt-neutral-50 border-y border-jmt-neutral-200 z-30 py-3 px-4">

					<div className="flex items-center justify-between">
						<p className="text-lg text-jmt-main font-bold"> جمع کل </p>
						<PriceComponent
							price={cart?.total_prices?.sum_product_price}
							className="text-lg font-bold text-jmt-neutral-900" />
					</div>
					<SubmitButton />

				</div>
			}
		</>
	)
}
export default Index
